import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7F7F7F",
      d: "M15.736 14.45a8.83 8.83 0 0 0 1.991-5.586C17.727 3.977 13.75 0 8.864 0 3.977 0 0 3.977 0 8.864c0 4.886 3.977 8.863 8.864 8.863 2.118 0 4.059-.75 5.586-1.99l4 4a.906.906 0 0 0 1.282-.005.91.91 0 0 0 0-1.287zm-6.872 1.46c-3.887 0-7.046-3.165-7.046-7.046s3.16-7.046 7.046-7.046a7.05 7.05 0 0 1 7.045 7.046c0 3.886-3.164 7.045-7.045 7.045"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search-icon"}) } }